import Tr from '@/i18n/translation';
import { RouteNames, RoutePaths } from './names';
import { useModifyLinkStore } from '@/stores/modifyLink/modifyLink.store';
import { IProductBundleState } from 'interface/db/userProductBundle';
import { IProductState } from 'interface/db/product';
import { useStateStore } from '@/stores/state.store';

export default {
  path: 'modify',
  redirect: Tr.i18nRoute({ name: 'Home' }),
  children: [
    {
      path: RoutePaths.ModifyId,
      name: RouteNames.ModifyId,
      component: () => import('@/views/ModifyView.vue'),
      beforeEnter: async (to, _from, next) => {
        const linkId = to.params['id'];
        const { trySetupData } = useModifyLinkStore();
        await trySetupData((linkId as string) ?? '');
        const { getLinkData } = useModifyLinkStore();
        if (
          (getLinkData.bundleState === IProductBundleState.UNKNOW &&
            getLinkData.productState === IProductState.UNKNOW) ||
          to.name === RouteNames.ModifyId
        ) {
          return next(Tr.i18nRoute({ name: 'Home' }));
        }
        next();
      },
      children: [
        {
          path: RoutePaths.TokenDate,
          name: RouteNames.TokenDate,
          component: () => import('@/views/modify/TokenDateView.vue'),
          beforeEnter: async (to, _from, next) => {
            const { getLinkData } = useModifyLinkStore();
            const params = to.params;
            if (getLinkData.bundleState !== IProductBundleState.NEW) {
              return next(
                Tr.i18nRoute({ name: RouteNames.FormFulfilled, params }),
              );
            }
            next();
          },
        },
        {
          path: RoutePaths.FormFulfilled,
          name: RouteNames.FormFulfilled,
          component: () => import('@/views/modify/FormFulfilled.vue'),
        },
        {
          path: RoutePaths.Event,
          name: RouteNames.Event,
          component: () => import('@/views/modify/EventView.vue'),
          beforeEnter: (to, _from, next) => {
            const { getLinkData } = useModifyLinkStore();
            const params = to.params;
            if (getLinkData.productState !== IProductState.NEW) {
              return next(
                Tr.i18nRoute({ name: RouteNames.FormFulfilled, params }),
              );
            }
            const stateStore = useStateStore();
            stateStore.disableButtons();
            next();
          },
        },
      ],
    },
  ],
};
